import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Layout, Drawer } from "antd";
import Sidenav from "./Sidenav";
import Header from "./Header";
import Footer from "./Footer";
import { useUser } from "../../contexts/User";
import Loader from "../spinner/Spinner";
import { useTranslation } from "react-i18next";
import { FaBell, FaComments, FaEdit, FaInbox, FaTachometerAlt, FaUserEdit, FaUsers } from "react-icons/fa";
import { FaBellConcierge } from "react-icons/fa6";

const { Header: Content, Sider } = Layout;

function Main() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const openDrawer = () => setVisible(!visible);
  const { user, loading } = useUser();

  if (loading) {
    return <Loader />;
  }

  if (!user) {
    window.location.href = "/auth/login";
  }

  const role = user.user_category.toUpperCase();
  console.log(role)

  // Define navItems based on user role
  let navItems = [];

  switch (role) {
    case "STAFFMAKER":
      navItems = [
        { label: t("sidenav.dashboard"), path: "dashboard", icon: <FaTachometerAlt/> },
        { label: t("sidenav.onboarding"), path: "onboarding", icon: <FaUsers/> },
        { label: t("sidenav.notifications"), path: "notifications", icon: <FaBell/> },
        { label: t("sidenav.notificationrequests"), path: "notification-requests", icon: <FaBellConcierge/> },
      ];
      break;
    case "CUSTOMER_SUPPORT":
      navItems = [
        { label: t("sidenav.dashboard"), path: "dashboard", icon: <FaTachometerAlt/> },
        { label: t("sidenav.notifications"), path: "notifications", icon: <FaBell/> },
        { label: t("sidenav.notificationrequests"), path: "notification-requests", icon: <FaBellConcierge/> },

      ];
      break;
    case "STAFFCHECKER":
      navItems = [
        { label: t("sidenav.dashboard"), path: "dashboard", icon: <FaTachometerAlt/> },
        { label: t("sidenav.myactions"), path: "my-actions", icon: <FaEdit/> },
      ];
      break;
    case "ADMIN":
      navItems = [
        { label: t("sidenav.dashboard"), path: "dashboard", icon: <FaTachometerAlt/> },
        { label: t("sidenav.usermanagement"), path: "users", icon: <FaUserEdit/> },
        { label: t("sidenav.billers"), path: "billers", icon: <FaUsers/> },
        { label: t("sidenav.notifications"), path: "notifications", icon: <FaBell/> },
        { label: "Sms", path: "sms", icon: <FaComments/> },
      ];
      break;
    case "RECON":
      navItems = [
        { label: t("sidenav.dashboard"), path: "dashboard", icon: <FaTachometerAlt/> },
        { label: "Reconcile", path: "reconcile", icon: <FaTachometerAlt/> },
      ];
      break;
    default:
      navItems = [];
      break;
  }

  return (
    <Layout className={`layout-dashboard`}>
      <Drawer
        title={false}
        placement="left"
        closable={false}
        onClose={() => setVisible(false)}
        open={visible}
        key="left"
        width={250}
        className="drawer-sidebar"
      >
        <Layout className="layout-dashboard">
          <Sider
            trigger={null}
            width={250}
            theme="light"
            className={`sider-primary ant-layout-sider-primary`}
            style={{ background: "transparent" }}
          >
            <Sidenav navItems={navItems} />
          </Sider>
        </Layout>
      </Drawer>
      <Sider
        breakpoint="lg"
        collapsedWidth="0"
        onCollapse={(collapsed, type) => {
          console.log(collapsed, type);
        }}
        trigger={null}
        width={250}
        theme="light"
        className={`sider-primary ant-layout-sider-primary`}
        style={{ background: "transparent" }}
      >
        <Sidenav navItems={navItems} />
      </Sider>
      <Layout
        style={{
          backgroundImage: "url('/imgs/bg.svg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
        }}
      >
        <div style={{ padding: 20, background: "transparent" }}>
          <Header onPress={openDrawer} />
        </div>
        <Content className="content-ant">
          <Outlet />
        </Content>
        <Footer />
      </Layout>
    </Layout>
  );
}

export default Main;
